import React, { useContext } from "react";
import { Chip } from "@mui/material";

import { CustomButton } from "../../../components";
import {
  CUSTOMER_TYPE_CHIP_COLORS,
  CUSTOMER_TYPE_LABELS,
  resolveCustomerType,
} from "../../../components/constants";

import css from "../account-details.module.css"
import { LoginContext } from "../../../context/login-context";
import Breadcrumb from "../../../components/Breadcrumb";

const CustomerInfoBlock = ({ account, onClick, btnRemove }) => {
  const { state: userData } = useContext(LoginContext);
  const customerType = resolveCustomerType(account);
  const chipColors = customerType ? CUSTOMER_TYPE_CHIP_COLORS[customerType] : null;

const info = (
  <div className={css.contact}>
   <Breadcrumb account={account} />
    {customerType && (
      <Chip
        label={CUSTOMER_TYPE_LABELS[customerType]}
        size="small"
        sx={{
          mt: 1,
          backgroundColor: chipColors.bg,
          color: chipColors.color,
          fontWeight: 500,
        }}
      />
    )}
    {account?.address && <p>{account?.address}</p>}
  </div>
);

  const btnEdit = onClick ? (
    <CustomButton
      label={`Edit ${account?.account_type == 'SUB_ENTITY' ? "Sub Account" : "Account"}`}
      onClick={onClick}
      color="secondary"
    />
  ): null;
  
  const btns = (
    <div className={css.actions}>
      {btnRemove && btnRemove}
      {btnEdit}
    </div>
  );

  return (
    <div className={css.info}>
      {info}
      {userData?.isValmontUser && btns}
    </div>
  )
};

export default CustomerInfoBlock;
